import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { Button as GarnishButton } from '../../../Button';
import { NAVBAR_CONTENT_HEIGHT } from '../../Navbar.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarButton = (props: Props) => {
  const { style, ...restProps } = props;

  return (
    <View style={styles.container}>
      <GarnishButton size="large" palette="primary" style={[styles.button, style]} {...restProps} />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexShrink: 1,
  },
  button: {
    height: NAVBAR_CONTENT_HEIGHT,
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof GarnishButton>, 'palette' | 'size'>;
